export default "__VITE_ASSET__94fe82ac__"